const EmailHeader = () => {
    return (
        <div className={`container-fluid py-2 py-3 d-flex column-gap-3 mb-3 rounded`} >
            <div className="d-flex column-gap-4 col-1 align-items-center"></div>
            <div className="d-flex col-11 column-gap-2">
                <div className="col-2  align-self-center ">
                    <p className="m-0 px-3 fw-bold text-black" style={{ fontSize: 14 }}>Sender's Email</p>
                </div>
                <div className="col-3  align-self-center">
                    <p className="m-0 fw-bold text-black" style={{ fontSize: 14 }}>Subject</p>
                </div>
                <div className="col-3  align-self-center">
                    <p className="m-0 fw-bold text-black" style={{ fontSize: 14 }}>Body Preview</p>
                </div>
                <div className="col-1  align-self-center">
                    <p className="m-0 fw-bold text-black" style={{ fontSize: 14 }}>Date</p>
                </div>
                <div className="col-1  align-self-center ">
                    <p className="m-0 fw-bold text-black" style={{ fontSize: 14 }}>Is Read</p>
                </div>
                <div className="col-2  align-self-center">
                    <p className="m-0 fw-bold text-black" style={{ fontSize: 14 }}>Action</p>
                </div>
            </div>
        </div>
    )
}

export default EmailHeader;